module.exports = __webpack_public_path__ + "static/media/PricingHeroTeam.1ab1888a.jpg";